/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST

export const violationAlertTypeQuery = params => {
  return axios.post(`${base}/violation_alert_type/query`, params)
}

export const violationAlertTypeOptions = params => {
  return axios.get(`${base}/violation_alert_type/options`, {params})
}

export const violationAlertTypeCreate = params => {
  return axios.post(`${base}/violation_alert_type/create`, params)
}

export const violationAlertTypeEdit = params => {
  return axios.post(`${base}/violation_alert_type/${params.id}/edit`, params)
}

export const violationAlertTypeGet = id => {
  return axios.get(`${base}/violation_alert_type/${id}`)
}

export const violationAlertTypeChangeStatus = params => {
  return axios.post(`${base}/violation_alert_type/change_status`, params)
}

export const violationAlertRecordQuery = params => {
  return axios.post(`${base}/violation_alert_record/query`, params)
}

export const violationAlertRecordGet = id => {
  return axios.get(`${base}/violation_alert_record/${id}`)
}

export const violationAlertRecordCreate = params => {
  return axios.post(`${base}/violation_alert_record/create`, params)
}

export const violationAlertRecordResolveUsers = params => {
  return axios.post(`${base}/violation_alert_record/resolve_users`, params)
}

export const violationAlertRecordQueryDetails = params => {
  return axios.post(`${base}/violation_alert_record/${params.id}/query_details`, params)
}

export const violationAlertRecordResendFailed = params => {
  return axios.post(`${base}/violation_alert_record/${params.id}/resend_failed`, params)
}

export const violationAlertRecordCheckRecall = params => {
  return axios.post(`${base}/violation_alert_record/${params.id}/check_recall`, params)
}

export const violationAlertRecordRecall = params => {
  return axios.post(`${base}/violation_alert_record/${params.id}/recall`, params)
}



// WEBPACK FOOTER //
// ./src/views/violation-alert/violation-alert.api.js